<template>
    <v-dialog v-model="visible" persistent max-width="600px">
        <v-card light>
            <v-card-title class="justify-center">
                <v-spacer/>
                <span class="text-h5">
                    {{ form.id ? 'Edição' : 'Cadastro' }} de Conta
                </span>
                <v-spacer/>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            label="Nome"
                            v-model="form.nome"
                            dense
                            outlined
                            hide-details
                        />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                            label="Descrição"
                            v-model="form.descricao"
                            dense
                            outlined
                            hide-details
                        />
                    </v-col>
                    <v-col cols="12">
                        <v-switch
                            v-model="form.ativo"
                            label="Ativo"
                            hide-details
                            class="mt-0"
                        />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn text color="warning" @click="$emit('close')">Cancelar</v-btn>
                <v-spacer/>
                <v-btn color="success" @click="salvar" :loading="loading">
                    <v-icon>mdi-content-save</v-icon>&nbsp;Salvar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ContaForm',

    props: {
        visible: { type: Boolean, default: false },
        formData: { type: Object, default: () => ({}) },
    },

    data: () => ({
        form: {},
        loading: false,
    }),

    watch: {
        formData(value) {
            this.form = value ? JSON.parse(JSON.stringify(value)) : {};
        },
    },

    methods: {
        salvar() {
            if (!this.form.nome) {
                alert('Informe o nome da conta');
                return;
            }

            const payload = {
                nome: this.form.nome,
                descricao: this.form.descricao || null,
                ativo: this.form.ativo !== false,
            };

            this.loading = true;
            const id = this.form.id;
            const req = id
                ? this.$http.put(`financeiro-interno/contas/${id}`, payload)
                : this.$http.post('financeiro-interno/contas', payload);

            req.then(() => this.$emit('onCadastro'))
                .catch(e => alert(e?.response?.data?.message || 'Erro ao salvar'))
                .finally(() => (this.loading = false));
        },
    },
}
</script>
